import { motion } from "framer-motion";
import WineClubCard from "./WineClubCard";

const WineClubsList = ({ wineClubs }) => {
	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 100 },
		show: { opacity: 1, y: 0 },
	};

	return (
		<motion.div
			variants={container}
			initial="hidden"
			animate="show"
			className="flex items-center justify-center flex-wrap"
		>
			{wineClubs.map((wineClub) => (
				<motion.div
					key={wineClub.id}
					variants={item}
					className="w-full max-w-320 sm:w-1/3 p-12"
				>
					<WineClubCard wineClub={wineClub} />
				</motion.div>
			))}
		</motion.div>
	);
};

export default WineClubsList;
